<template>
    <div class="p-3">
        <h3>Scan Berkas RM</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Tanggal Daftar</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                            <span class="input-group-text">s/d</span>
                            <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Status Scan</label>
                    <div class="col-sm-8 mt-2">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" name="status_scan" type="radio" id="inlineCheckbox1" value="semua" v-model="filter.status_scan">
                            <label class="form-check-label" for="inlineCheckbox1">Semua</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" name="status_scan" type="radio" id="inlineCheckbox2" value="sudah" v-model="filter.status_scan">
                            <label class="form-check-label" for="inlineCheckbox2">Sudah</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" name="status_scan" type="radio" id="inlineCheckbox3" value="belum" v-model="filter.status_scan">
                            <label class="form-check-label" for="inlineCheckbox3">Belum</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">No. RM/Nama/NIK/No Kartu BPJS</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Data Pasien</h4>
            <div class="col">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>No Rekam Medis</th>
                            <th>Nama</th>
                            <th>Tanggal Lahir</th>
                            <th>NIK</th>
                            <th>No Kartu BPJS</th>
                            <th>Tanggal Daftar</th>
                            <th>Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="pasien in master_pasiens" :key="pasien.Medrec">
                            <td></td>
                            <td>{{ pasien.Medrec }}</td>
                            <td>{{ pasien.Firstname }}</td>
                            <td>{{ pasien.Bod }}</td>
                            <td>{{ pasien.NoIden }}</td>
                            <td>{{ pasien.AskesNo }}</td>
                            <td>{{ pasien.tgl_daftar }}</td>
                            <td><router-link :to="`/scan-berkas-rm/${pasien.Medrec}`" class="btn btn-sm btn-primary">Detail</router-link></td>
                        </tr>
                    </tbody>
                </table>

                <Pagination
                    :key="filter.total"
                    :totalItems="filter.total"
                    :itemsPerPage="filter.per_page"
                    :maxPageButtons="10"
                    :page.sync="filter.page"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../../global/Pagination.vue';

export default {
    data() {
        return {
            master_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                status_scan: 'semua',
                search: '',
                per_page: 20,
                page: 1,
                total: 0
            }
        }
    },
    components: {
        Pagination
    },
    created() {
        this.getAllPasien()
    },
    methods: {
        getAllPasien() {
            const uri = `/api/scan-berkas-rm/get-all-pasien?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&status_scan=${this.filter.status_scan}&search=${this.filter.search}&page=${this.filter.page}`

            this.axios.get(uri).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.master_pasiens = response.data.master_pasiens.data
                    this.filter.total = response.data?.master_pasiens?.total ?? 0
                }
            })
        },
        gantiNomorRM(medrec) {
            const uri = '/api/status-pasien/nonaktif-pasien'
            const data_pasien = {
                medrec: medrec
            }

            this.axios.post(uri, data_pasien).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.getAllPasien()
                }
            })
        },
        aktifPasien(medrec) {
            const uri = '/api/status-pasien/aktif-pasien'
            const data_pasien = {
                medrec: medrec
            }

            this.axios.post(uri, data_pasien).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.getAllPasien()
                }
            })
        },
        resetFilters() {
            this.filter = {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }

            this.getAllPasien()
        },
    },
    watch: {
        'filter.page'(newVal, oldVal) {
            console.log('watch update', newVal, oldVal)
            if (newVal !== oldVal) {
                this.getAllPasien()
            }
        }
    }
}
</script>
